/* eslint-disable max-len */
import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

class IconCalendar18 extends React.Component {
  render() {
    const iconClasses = classNames("icon calendar18", this.props.className);
    return (
      <svg
        className={iconClasses}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 30 30"
      >
        <path d="M 6 4 C 4.895 4 4 4.895 4 6 L 4 24 C 4 25.105 4.895 26 6 26 L 24 26 C 25.105 26 26 25.105 26 24 L 26 6 C 26 4.895 25.105 4 24 4 L 6 4 z M 6 6 L 24 6 L 24 10 L 6 10 L 6 6 z M 18.1875 14.306641 C 19.7745 14.306641 20.912109 15.122 20.912109 16.25 C 20.912109 16.992 20.38475 17.598531 19.59375 17.769531 L 19.59375 17.861328 C 20.55575 18.037328 21.199219 18.750438 21.199219 19.648438 C 21.197219 20.893437 19.982641 21.734375 18.181641 21.734375 C 16.384641 21.734375 15.177734 20.904062 15.177734 19.664062 C 15.177734 18.795063 15.807297 18.086328 16.779297 17.861328 L 16.779297 17.769531 C 15.988297 17.598531 15.462891 16.993 15.462891 16.25 C 15.462891 15.122 16.6005 14.306641 18.1875 14.306641 z M 10.583984 14.496094 L 12.376953 14.496094 L 12.376953 21.542969 L 10.583984 21.542969 L 10.583984 16.113281 L 10.490234 16.113281 L 8.7929688 17.259766 L 8.7929688 15.716797 L 10.583984 14.496094 z M 18.185547 15.53125 C 17.623547 15.53125 17.224609 15.908016 17.224609 16.416016 C 17.224609 16.924016 17.628547 17.294922 18.185547 17.294922 C 18.742547 17.294922 19.142578 16.924016 19.142578 16.416016 C 19.142578 15.908016 18.742547 15.53125 18.185547 15.53125 z M 18.185547 18.515625 C 17.516547 18.515625 17.052734 18.920094 17.052734 19.496094 C 17.052734 20.077094 17.516547 20.474609 18.185547 20.474609 C 18.854547 20.474609 19.314453 20.077094 19.314453 19.496094 C 19.313453 18.920094 18.849547 18.515625 18.185547 18.515625 z" />
      </svg>
    );
  }
}

IconCalendar18.defaultProps = {
  className: null
};

IconCalendar18.propTypes = {
  className: PropTypes.string
};

export default IconCalendar18;
